/**
 * ColumnEventListRow — `column.event-list` renderer. Paints the
 * enclosing event aggregate's events for the column as a flat
 * vertical list. Declared by the calendar-list alias template
 * (slot `column`); the DOM plugin reads events through the alias
 * ancestor's aggregate facade.
 */

import { RendererRow } from "./renderer-row.ts";

export class ColumnEventListRow extends RendererRow {}
